import { useCallback, useState } from 'react';

export const useSwitcher = <T extends {}>(values: T[]): [T | undefined, () => void] => {
  const [value, setValue] = useState<T | undefined>(values[0]);

  const switchValue = useCallback(() => {
    if (typeof value === 'undefined') {
      return;
    }
    const currentValueIndex = values.indexOf(value);
    const newValueIndex = currentValueIndex === values.length - 1 ? 0 : currentValueIndex + 1;

    setValue(values[newValueIndex]);
  }, [value, values]);

  return [value, switchValue];
};
